// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"242":"ff789227","252":"e486d6c3","262":"25a4d8a5","375":"6772b2a9","722":"f6001c22","787":"1b5bed45","810":"90906f20","957":"4647abdc"}[chunkId] + ".chunk.js";
};